import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1b8dc96c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "scroll-wrap"
};
const _hoisted_2 = {
  class: "scrollbar-wrap"
};
const _hoisted_3 = {
  class: "container-xxl main"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "效果演示", -1));

const _hoisted_5 = {
  class: "list-unstyled mb-0 py-3 pt-md-1"
};
const _hoisted_6 = ["data-bs-target"];
const _hoisted_7 = ["id"];
const _hoisted_8 = {
  class: "list-unstyled fw-normal pb-1 small"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "bd-sidebar"
};
const _hoisted_11 = {
  class: "bd-links collapse",
  id: "bd-demo-nav",
  "aria-label": "Docs navigation",
  style: {}
};
const _hoisted_12 = {
  class: "list-unstyled mb-0 py-3 pt-md-1"
};
const _hoisted_13 = ["data-bs-target"];
const _hoisted_14 = ["id"];
const _hoisted_15 = {
  class: "list-unstyled fw-normal pb-1 small"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "demo-content order-1"
};
import menu from "./menu";
import { onMounted, ref, shallowRef, defineAsyncComponent, watch, inject } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import DefaultDemoContent from "@/components/demo/DefaultDemoContent.vue";
import RightAsideNavBar from "@/components/nav/RightAsideNavBar.vue"; // import { useScreenType, smallScreen, largeScreen } from "@/stores/screenType";
// fs是服务端模块，无法使用
// import { readFile } from 'fs';

export default {
  __name: 'HomeDemoPage',

  setup(__props) {
    const route = useRoute();
    const categories = ref(menu.categories);
    const showRightNavBar = ref(false);
    const tmpFlag = ref(true);
    categories.value.forEach(category => {
      const childrenJson = require(`@/components/demo/${category.path}/list.json`);

      childrenJson.demos.map(demo => {
        if (demo.name.trim() == "") {
          demo.name = demo.path.split(".")[0];
        }
      });
      childrenJson.demos = childrenJson.demos.filter(demo => demo.name[0] !== '_');
      category.children = childrenJson.demos;
    });
    const activeDemoPath = ref("");
    const demoContent = shallowRef(DefaultDemoContent);
    const componentsList = [];

    function viewDemoDetail(event, category, name) {
      event.preventDefault();
      let path = `@/components/demo/${category}/${name}`;

      if (activeDemoPath.value === path) {
        return;
      }

      activeDemoPath.value = path;
      let component = componentsList.find(item => {
        item.path === path;
      });

      if (component === undefined) {
        component = defineAsyncComponent(() => // 这是如何实现的
        import(`@/components/demo/${category}/${name}`) // import(path) // 这样写不行
        );
        componentsList.push({
          path,
          component
        });
      }

      demoContent.value = component;
      showRightNavBar.value = false;
    }

    const touchState = {
      x: -1,
      y: -1
    };

    function handleTouchstart(event) {
      touchState.x = event.touches[0].clientX;
      touchState.y = event.touches[0].clientY;
    }

    let moveTime = null;

    function handleTouchmove(event) {
      // 100ms内之后执行最后一次触发
      // 之前的被clear
      if (moveTime !== null) {
        clearTimeout(moveTime);
      }

      moveTime = setTimeout(() => {
        let x = event.touches[0].clientX;
        let y = event.touches[0].clientY;
        let x_ = touchState.x;

        if (x_ - x >= 100) {
          showRightNavBar.value = true;
        }

        console.log(x_ - x);
      }, 200);
    } // touchend 没有touch对象


    function handleTouchend(event) {}

    function handleCloseNav() {
      showRightNavBar.value = false;
    }

    onMounted(() => {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.target === document.querySelector("#bd-demo-nav")) {
            if (entry.isIntersecting) {
              showRightNavBar.value = false;
              window.removeEventListener("touchstart", handleTouchstart, true);
              window.removeEventListener("touchmove", handleTouchmove, true);
              window.removeEventListener("touchend", handleTouchend, true);
            } else {
              showRightNavBar.value = true;
              window.addEventListener("touchstart", handleTouchstart, true);
              window.addEventListener("touchmove", handleTouchmove, true);
              window.addEventListener("touchend", handleTouchend, true);
            }
          }
        });
      });
      observer.observe(document.querySelector("#bd-demo-nav"));
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [showRightNavBar.value ? (_openBlock(), _createBlock(RightAsideNavBar, {
        key: 0,
        mask: true,
        onCloseNav: handleCloseNav
      }, {
        header: _withCtx(() => [_hoisted_4]),
        main: _withCtx(() => [_createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, category => {
          return _openBlock(), _createElementBlock("li", {
            class: "mb-1",
            key: category.name
          }, [_createElementVNode("button", {
            class: "btn d-inline-flex align-items-center rounded collapsed",
            "data-bs-toggle": "collapse",
            "data-bs-target": `#${category.name}-collapse`,
            "aria-expanded": "false",
            "aria-current": "true"
          }, _toDisplayString(category.name), 9, _hoisted_6), _createElementVNode("div", {
            class: "collapse",
            id: `${category.name}-collapse`,
            style: {}
          }, [_createElementVNode("ul", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.children, item => {
            return _openBlock(), _createElementBlock("li", {
              key: item.path
            }, [_createElementVNode("a", {
              style: {
                "cursor": "pointer"
              },
              onClick: event => viewDemoDetail(event, category.path, item.path),
              class: "d-inline-flex align-items-center rounded",
              "aria-current": "page"
            }, _toDisplayString(item.name), 9, _hoisted_9)]);
          }), 128))])], 8, _hoisted_7)]);
        }), 128))])]),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("aside", _hoisted_10, [_createElementVNode("nav", _hoisted_11, [_createElementVNode("ul", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, category => {
        return _openBlock(), _createElementBlock("li", {
          class: "mb-1",
          key: category.name
        }, [_createElementVNode("button", {
          class: "btn d-inline-flex align-items-center rounded collapsed",
          "data-bs-toggle": "collapse",
          "data-bs-target": `#${category.name}-collapse`,
          "aria-expanded": "false",
          "aria-current": "true"
        }, _toDisplayString(category.name), 9, _hoisted_13), _createElementVNode("div", {
          class: "collapse",
          id: `${category.name}-collapse`,
          style: {}
        }, [_createElementVNode("ul", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.children, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.path
          }, [_createElementVNode("a", {
            style: {
              "cursor": "pointer"
            },
            onClick: event => viewDemoDetail(event, category.path, item.path),
            class: _normalizeClass(["d-inline-flex align-items-center rounded", {
              active: activeDemoPath.value === `./${category.path}/${item.path}`
            }]),
            "aria-current": "page"
          }, _toDisplayString(item.name), 11, _hoisted_16)]);
        }), 128))])], 8, _hoisted_14)]);
      }), 128))])])]), _createElementVNode("main", _hoisted_17, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(demoContent))))])])])]);
    };
  }

};